import styles from './template.css';
import template from './template';
import {AoflElement, customElement, property} from '@aofl/element';
import {i18nMixin} from '@aofl/i18n-mixin';
import {storeInstance} from '@aofl/store/dist/legacy';
import translations from '@modules/i18n';
import {SimpleModal} from '@modules/simple-modal';
import {validationMixin} from '@aofl/form-validate';
import {sdoNs, pages} from '@modules/constants-enumerate';
import {ApiService} from '@modules/api-service';
import '@routes/parent/modules/__config/modals';
import {routerInstance} from '@aofl/router';

/**
 * @summary RedeemCodeModal
 * @extends {i18nMixin(AoflElement)}
 */
@customElement('redeem-code-modal')
class RedeemCodeModal extends validationMixin(i18nMixin(AoflElement)) {
  /**
   * Creates an instance of LicenseRevokeModal.
   */
  constructor() {
    super();
    this.translations = translations;
  }

  /**
   * @readonly
   */
  static is = 'redeem-code-modal';

  @property({type: Object, mapState: `${sdoNs.SESSION}`, store: storeInstance})
  sessionInfo = {};

  @property({type: Boolean})
  submitting = false;

  @property({type: Number})
  errorCode

  close() {
    SimpleModal.hide();
  }

  firstUpdated(changedProperties) {
    this.shadowRoot.querySelector('[tabindex="0"]').focus();
  }

  async codeSubmitted(e) {
    this.submitting = true;

    try {
      const resp = await ApiService.userVerifyActivationCode(e.detail.code);

      if (resp.products.length > 0) {
        await ApiService.parentAddChild(this.sessionInfo.id, e.detail.code);
      }

      routerInstance.navigate(pages.PARENT_HOMEPAGE, {forceReload: true});
      this.close();
    } catch (error) {
      this.errorCode = error.error.code;
    } finally {
      this.submitting = false;
    }
  }

  /**
   *
   * @return {Object}
   */
  render() {
    return super.render({
      default: {
        template,
        styles: [styles]
      }
    });
  }
}

export default RedeemCodeModal;
